
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import progressBar from '@/components/progress.vue';

export default {
components: {
progressBar
},
name: 'showProgress',
data() {
return {
progresses: [0, 100, 60]
};
},
methods: {

},
watch: {},
computed: {

},
created() {},
mounted() {}
};
